import config from './config'
import { resolveMediaInData } from './media'

const request = (options) => {
  return new Promise((resolve, reject) => {
    uni.request({
      url: config.baseURL + options.url,
      method: options.method || 'GET',
      data: options.data || {},
      header: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${uni.getStorageSync('token') || ''}`,
        ...options.header
      },
      success: (res) => {
        if (res.data && res.data.code === 401) {
          uni.removeStorageSync('token')
          // 不强制 reLaunch 登录页，避免浏览市场等页面被反复拉去登录（审核要求可取消/返回）
          reject(res)
        } else if (res.statusCode === 200) {
          const body = res.data
          if (body && typeof body === 'object') {
            const skip = new Set(['code', 'msg'])
            for (const key of Object.keys(body)) {
              if (!skip.has(key) && body[key] != null) {
                body[key] = resolveMediaInData(body[key])
              }
            }
          }
          resolve(body)
        } else if (res.statusCode === 401) {
          uni.removeStorageSync('token')
          reject(res)
        } else {
          reject(res.data?.msg ? res.data : { msg: typeof res.data === 'string' ? res.data : `请求失败(${res.statusCode})`, data: res.data })
        }
      },
      fail: (err) => {
        reject(err)
      }
    })
  })
}

export default request
